import { initBackgroundMessaging } from "@/utils/messaging";
import { registerRootComponent } from "expo";
import { Platform } from "react-native";
import "react-native-gesture-handler";
import "react-native-get-random-values";
import "react-native-reanimated";
import App from "./App";

if (Platform.OS !== "web") {
  initBackgroundMessaging();
}

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
